module.exports = __webpack_public_path__ + "img/check-square.97520fe6.svg";